/* MotoWing: koleksiyon sayfası hızlı filtre çubuğu (snippets/motowing-colbar). Sırala paneli, Filtrele (temanın filtre çekmecesi), "Motorunu seç" çipi, telefonda yapışkan çubuk, boş sonuç önerisi. */
(function(){
  var box=document.querySelector('[data-mw-cb]'); if(!box||box.mwInit) return; box.mwInit=1;
  var ph=box.querySelector('[data-mw-cb-ph]'), bar=box.querySelector('[data-mw-cb-bar]');
  var PG='filter.v.price.gte', PL='filter.v.price.lte', DEF=box.getAttribute('data-def')||'';
  var RM=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var S=[]; try{ var a=JSON.parse(box.querySelector('[data-mw-cb-sorts]').textContent)||[]; for(var i=0;a.length>i+1;i+=2) S.push([a[i],a[i+1]]); }catch(e){}
  document.body.classList.add('mw-cb-on');

  function params(){ return new URLSearchParams(window.location.search); }
  function apply(p){
    p.delete('page');
    var s=p.toString(), F=window.customElements&&customElements.get('facet-filters-form');
    if(F&&typeof F.renderPage==='function'&&document.getElementById('product-grid')){
      F.renderPage(s);
      var g=document.getElementById('ProductGridContainer');
      if(g&&ph&&ph.getBoundingClientRect().top<0){ var y=window.scrollY+box.getBoundingClientRect().top-80; window.scrollTo({top:Math.max(0,y),behavior:RM?'auto':'smooth'}); }
      sync();
    } else window.location.href=window.location.pathname+(s?'?'+s:'');
  }
  /* Durumu adresten oku: filtre sayısı, sıralama, boş sonuç */
  function sync(){
    var p=params(), n=0, seen={};
    p.forEach(function(v,k){ if(k.indexOf('filter.')!==0||v==='') return; if(k===PG||k===PL){ if(!seen.pr){ seen.pr=1; n++; } return; } n++; });
    var nb=box.querySelector('[data-mw-cb-n]'), fl=box.querySelector('[data-mw-cb-fl]');
    if(nb){ nb.textContent=n; nb.hidden=n<1; }
    if(fl) fl.textContent=n>0?n+' filtre seçili':'Marka, model, fiyat';
    var sv=p.get('sort_by')||DEF, sl=box.querySelector('[data-mw-cb-sl]');
    if(sl) S.forEach(function(x){ if(x[0]===sv) sl.textContent=x[1]; });
    var sbn=box.querySelector('[data-mw-cb-sort]'); if(sbn) sbn.classList.toggle('is-on',sv!==DEF);
    [].forEach.call(document.querySelectorAll('select[name="sort_by"]'),function(x){ if(x.value!==sv&&x.querySelector('option[value="'+sv+'"]')) x.value=sv; });
  }
  function counts(){
    var gc=document.getElementById('ProductGridContainer'); if(!gc) return;
    var em=gc.querySelector('.collection--empty');
    if(em&&!gc.querySelector('.mw-cb-empty')){
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', d=document.createElement('div');
      d.className='mw-cb-empty page-width';
      d.innerHTML='<p class="mw-cb-empty__t">Bu seçimle ürün bulunamadı. Aradığın parçayı senin için bulalım.</p><div class="mw-cb-empty__a"><a class="mw-cb-empty__b" href="'+box.getAttribute('data-url')+'">Filtreleri temizle</a><a class="mw-cb-empty__b is-r" href="'+root+'pages/garajim#talep">Parça talebi gönder</a><a class="mw-cb-empty__b is-g" href="https://wa.me/905016050642?text='+encodeURIComponent('Merhaba, sitede bulamadığım bir ürünü soracaktım: ')+'" target="_blank" rel="noopener">WhatsApp\'tan sor</a></div>';
      em.appendChild(d);
    }
  }
  /* "Motorunu seç" daveti büyük kutu yerine kategori çiplerinin başında (kutu telefonda CSS ile gizli); çip satırı yoksa çubuğun altında */
  var mli=box.querySelector('[data-mw-cb-moto]'), row=box.querySelector('[data-mw-cb-row]');
  if(mli&&document.querySelector('.mw-myfit.is-ask')){
    var cl=document.querySelector('.mw-cnav__list');
    if(cl){ var sx=cl.scrollLeft; mli.querySelector('a').className='mw-cnav__chip mw-cnav__chip--moto'; cl.insertBefore(mli,cl.firstChild); if(sx>0) cl.scrollLeft=sx+mli.getBoundingClientRect().width+8; }
    else if(row) row.hidden=false;
  }
  sync(); counts();
  var gc=document.getElementById('ProductGridContainer');
  if(gc&&window.MutationObserver) new MutationObserver(function(){ sync(); counts(); }).observe(gc,{childList:true});
  window.addEventListener('popstate',function(){ setTimeout(sync,0); });

  /* Filtrele: temanın filtre çekmecesi */
  var fb=box.querySelector('[data-mw-cb-filter]');
  if(fb) fb.addEventListener('click',function(){
    var s=document.querySelector('.mobile-facets__wrapper summary');
    if(s&&s.getClientRects().length===0&&window.innerWidth>749) s=null;
    if(s){ s.click(); return; }
    var f=document.querySelector('.facets-wrapper'); if(f) f.scrollIntoView({behavior:RM?'auto':'smooth',block:'start'});
  });

  /* Sırala paneli */
  var SS=null, last=null;
  function build(){
    SS=document.createElement('div'); SS.className='mw-ss'; SS.id='mw-ss'; SS.hidden=true;
    var h='<span class="mw-ss__ov" data-mw-ss-x></span><div class="mw-ss__box" role="dialog" aria-modal="true" aria-labelledby="mw-ss-t" tabindex="-1"><span class="mw-ss__grab" aria-hidden="true"></span><div class="mw-ss__hd"><p class="mw-ss__t" id="mw-ss-t">Sırala</p><button type="button" class="mw-ss__x" data-mw-ss-x aria-label="Kapat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="mw-ss__l" role="radiogroup" aria-labelledby="mw-ss-t"></div></div>';
    SS.innerHTML=h; document.body.appendChild(SS);
    var l=SS.querySelector('.mw-ss__l');
    S.forEach(function(x){ var b=document.createElement('button'); b.type='button'; b.className='mw-ss__o'; b.setAttribute('role','radio'); b.setAttribute('data-v',x[0]); b.textContent=x[1]; l.appendChild(b); });
    SS.addEventListener('click',function(e){
      if(e.target.closest('[data-mw-ss-x]')){ close(); return; }
      var o=e.target.closest('.mw-ss__o'); if(!o) return;
      var v=o.getAttribute('data-v'), p=params();
      if(v===DEF) p.delete('sort_by'); else p.set('sort_by',v);
      [].forEach.call(document.querySelectorAll('select[name="sort_by"]'),function(x){ x.value=v; });
      close(); apply(p);
    });
    document.addEventListener('keydown',function(e){ if(SS&&!SS.hidden&&e.key==='Escape') close(); });
    var bx=SS.querySelector('.mw-ss__box'), y0=null;
    bx.addEventListener('touchstart',function(e){ y0=bx.scrollTop>0?null:e.touches[0].clientY; },{passive:true});
    bx.addEventListener('touchend',function(e){ if(y0!==null&&e.changedTouches[0].clientY-y0>70) close(); y0=null; });
  }
  function open(from){
    if(!SS) build();
    last=from||null;
    var sv=params().get('sort_by')||DEF;
    [].forEach.call(SS.querySelectorAll('.mw-ss__o'),function(o){ var on=o.getAttribute('data-v')===sv; o.classList.toggle('is-on',on); o.setAttribute('aria-checked',on?'true':'false'); });
    SS.hidden=false; document.documentElement.classList.add('mw-ss-lock'); void SS.offsetWidth; SS.classList.add('is-open');
    var on=SS.querySelector('.mw-ss__o.is-on')||SS.querySelector('.mw-ss__box'); on.focus({preventScroll:true});
  }
  function close(){
    if(!SS||SS.hidden) return;
    SS.classList.remove('is-open'); document.documentElement.classList.remove('mw-ss-lock');
    setTimeout(function(){ if(!SS.classList.contains('is-open')) SS.hidden=true; },RM?0:260);
    if(last&&last.focus) last.focus({preventScroll:true});
  }
  var sb=box.querySelector('[data-mw-cb-sort]');
  if(sb) sb.addEventListener('click',function(){ open(sb); });

  /* Telefonda yapışkan çubuk: başlık görünürse onun altına, ürünler bitince gizlenir */
  if(!ph||!bar) return;
  var mq=window.matchMedia('(max-width: 749px)'), hd=document.querySelector('.section-header'), fixed=false, tk=false;
  function hTop(){
    if(!hd||!hd.classList.contains('shopify-section-header-sticky')||hd.classList.contains('shopify-section-header-hidden')) return 0;
    var r=hd.getBoundingClientRect(); return r.bottom>0?Math.round(r.bottom):0;
  }
  function upd(){
    tk=false;
    if(!mq.matches){ if(fixed){ fixed=false; box.classList.remove('is-fixed'); bar.style.top=''; bar.classList.remove('is-gone'); } return; }
    var t=hTop(), r=ph.getBoundingClientRect(), want=r.top<t;
    if(want!==fixed){ fixed=want; box.classList.toggle('is-fixed',want); if(!want){ bar.style.top=''; bar.classList.remove('is-gone'); } }
    if(fixed){
      bar.style.top=t+'px';
      var g=document.getElementById('ProductGridContainer'), gb=g?g.getBoundingClientRect().bottom:1e9;
      bar.classList.toggle('is-gone',gb<t+bar.offsetHeight+60);
    }
  }
  function req(){ if(!tk){ tk=true; requestAnimationFrame(upd); } }
  window.addEventListener('scroll',req,{passive:true});
  window.addEventListener('resize',req);
  if(hd&&window.MutationObserver) new MutationObserver(function(){ req(); setTimeout(req,180); }).observe(hd,{attributes:true,attributeFilter:['class']});
  upd();
})();